<template>
  <div
    v-if="surveyLink"
    class="section"
  >
    <div class="container max-width-mobile">
      <div class="layout layout--horizontal">
        <p class="dark grow">
          We'd appreciate your feedback!
        </p>

        <a
          class="button button--light button--auto-width"
          target="_blank"
          :href="surveyLink"
        >
          Take Survey
        </a>
      </div>
    </div>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import http from '@/services/http';
  import returnExternalHosts from '@/helpers/return-external-hosts';
  import { mapGetters } from 'vuex';



  export default {
    name: 'SurveyLink',

    props: {
      order: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        surveyLink: null
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    },

    created() {
      this.loadSurveyLink();
    },

    methods: {
      buildSurveyLink(form) {
        const host = returnExternalHosts().selfService;
        this.surveyLink = `${host}/merchant/${this.merchant.id}/survey/${form.formType}?orderId=${this.order.orderId}&source=${form.merchantFormPlatformType}`;
      },

      findMatchingSurvey(allForms) {
        const formTypes = {
          OrderAhead: 'OrderAheadSurvey',
          OrderAndPay: 'OrderAtTableSurvey',
          PayAndFulfill: 'PayAtTableSurvey'
        };
        const formType = formTypes[this.order.orderType] || 'OrderSurvey';
        const activeForms = allForms.filter(form => form.isActive);

        let matchingSurvey = activeForms.find(form => form.formType === formType);

        if (!matchingSurvey) {
          matchingSurvey = activeForms.find(form => form.formType === 'OrderSurvey');
        }

        if (matchingSurvey) {
          this.buildSurveyLink(matchingSurvey);
        }
      },

      async loadSurveyLink() {
        try {
          this.surveyLink = null;

          if (!this.merchant.features['enable-surveys']) {
            return;
          }

          const response = await http.get('/cardfree-api/v1/form', {
            params: {
              platform: 'Web'
            }
          });

          this.findMatchingSurvey(response.data);
        }

        catch (error) {
          errorHandlers.silent(error);
        }
      }
    }
  };
</script>
